import { combineReducers } from 'redux';

import selectedImagePairs from './selectedImagePairs';
import timelineOpen from './timelineOpen';
import auditArea from './auditArea';
import creatingRiverBoundaries from './creatingRiverBoundaries';
import buffer from './buffer';
import selectedMergeIntersectLayers from './selectedMergeIntersectLayers';
import selectedMergeIntersectOperation from './selectedMergeIntersectOperation';
import currentImagePair from './currentImagePair';

const auditdata = combineReducers({
  auditArea,
  selectedImagePairs,
  timelineOpen,
  creatingRiverBoundaries,
  buffer,
  selectedMergeIntersectLayers,
  selectedMergeIntersectOperation,
  currentImagePair
});

export default auditdata;
